<template>
  <ihris-element :edit="edit" :loading="false">
    <template #form>
      <v-text-field
          v-model="value"
          :append-icon="isPassword ? (showPassword ? 'mdi-eye' : 'mdi-eye-off') : ''"
          :disabled="disabled"
          :error-messages="errors"
          :label="display"
          :rules="rules"
          :type="isPassword ? (showPassword ? 'text' : 'password') : 'text'"
          dense
          hide-details="auto"
          outlined
          @change="errors = []"
          @click:append="showPassword = !showPassword"
      >
        <template #label>{{ display }}<span v-if="required" class="red--text font-weight-bold">*</span></template>
      </v-text-field>
    </template>
    <template #header>
      {{ display }}
    </template>
    <template #value>
      <div v-if="hrlProfession=true">
          <span v-for="profs in hrlProfs" :key="profs">
            {{ profs }} <br>
          </span>
      </div>
      {{ value }}
    </template>
  </ihris-element>
</template>

<script>
import IhrisElement from "../ihris/ihris-element.vue"

export default {
  name: "fhir-string",
  props: ["field", "label", "min", "max", "id", "path", "slotProps", "sliceName", "base-min", "base-max", "edit", "readOnlyIfSet",
    "constraints", "displayType"],
  components: {
    IhrisElement
  },
  data: function () {
    return {
      source: {path: "", data: {}},
      value: "",
      showPassword: false,
      qField: "valueString",
      disabled: false,
      errors: [],
      lockWatch: false,
      hrlProfession: false,
      hrlProfs: []
    }
  },
  created: function () {
    this.setupData()
  },

  watch: {
    slotProps: {
      handler() {
        //console.log("WATCH STRING",this.field,this.path,this.slotProps)
        if (!this.lockWatch) {
          this.setupData()
        }
      },
      deep: true
    }
  },
  methods: {
    setupData() {
      if (this.id === "Basic.extension:count.extension:count.value[x]:valueString" && this.label === "Number of Employee Required") {
        this.readOnlyIfSet = true;
      }
      this.$root.$on("salaryScaleIsSelected", (data) => {
        if (this.path === "PractitionerRole.salary") {
          this.value = data;
        }
      });

      if (this.path === "Practitioner.age" || this.path === "PractitionerRole.salary"
          || this.profile == "http://ihris.org/fhir/StructureDefinition/ihris-practitioner-retirementdate" || this.slotProps?.source?.path === "Practitioner.extension:age" || this.slotProps?.source?.path === "Practitioner.extension:retirementDate") {
        this.disabled = true
      }
      if (this.slotProps && this.slotProps.source) {
        this.source = {path: this.slotProps.source.path + "." + this.field, data: {}}
        if (this.slotProps.source.fromArray) {
          this.source.data = this.slotProps.source.data
          this.value = this.source.data
          this.lockWatch = true
        } else {
          let expression = this.$fhirutils.pathFieldExpression(this.field)
          this.source.data = this.$fhirpath.evaluate(this.slotProps.source.data, expression)
          if (this.source.data.length == 1) {
            this.value = this.source.data[0]
            this.lockWatch = true
          }
        }
        if (this.$router.history.current.name != "resource_add") {
          this.disabled = this.readOnlyIfSet && (!!this.value)
        }
        if (this.slotProps.source.path == "Practitioner.extension:age" || this.slotProps.source.path == "Practitioner.extension:retirementDate") {
          this.disabled = true
        }

      }
      if (this.source.path == "Basic.extension:ihrislicense.extension:professionName.value[x]:valueString" ||
          this.source.path == "Basic.extension:ihrislicenserenewal.extension:professionName.value[x]:valueString" ||
          this.source.path == "Basic.extension:ihrisgoodstanding.extension:professionName.value[x]:valueString") {
        this.hrlProfession = true
        this.value = ""
        this.hrlProfs = this.source.data[0].split(',')
      }
    }
  },
  mounted() {
  },
  computed: {
    index: function () {
      if (this.slotProps && this.slotProps.input) return this.slotProps.input.index
      else return undefined
    },
    display: function () {
      if (this.slotProps && this.slotProps.input) return this.slotProps.input.label
      else return this.label
    },
    required: function () {
      return (this.index || 0) < this.min
    },
    rules: function () {
      if (this.required) {
        return [v => !!v || this.display + " is required"]
      } else {
        return []
      }
    },
    isPassword: function () {
      return this.displayType === 'password'
    }
  }
}
</script>